// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BrandListItem__icon":"us_a bhb_jx","BrandListItem__name":"us_b bhb_uj"};